// src/components/project/ProjectPage.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { projectService, userService } from "../../services/api";
import "../../styles/ProjectPage.css"; // Adapte le chemin si besoin
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";

export default function ProjectPage() {
  const { id } = useParams();
  const { currentUser } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Récupérer le projet
    projectService
      .getProject(id)
      .then((res) => setProject(res.data))
      .catch((err) => console.error("Erreur projet:", err));

    // Récupérer l'utilisateur courant (optionnel)
    userService
      .getCurrentUser()
      .then((res) => setUser(res.data))
      .catch(() => {});
  }, [id]);
  useEffect(() => {
    if (currentUser) {
      setIsAdmin(currentUser.profile.role === "admin");
      console.log("isAdmin:", isAdmin);
    }
  }, [currentUser]);

  if (!project) {
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>Chargement...</div>
    );
  }

  return (
    <div style={{ marginTop: 50 }}>
      {/* Header */}
      <div>{/* create 2 buttom to validate orreject the project */}</div>

      {/* Main */}
      <main className="container">
        {isAdmin && project.status === "pending" && (
          <div className="admin-buttons">
            <button
              className="btn btn-success"
              onClick={() => {
                projectService
                  .validateProject(id)
                  .then(() => {
                    // navigate("/projects/" + id);
                    window.location.reload();
                  })
                  .catch((err) => console.error("Erreur validation:", err));
              }}
            >
              Valider le projet
            </button>
            <button
              className="btn btn-danger"
              onClick={() => {
                projectService
                  .rejectProject(id)
                  .then(() => {
                    // navigate("/projects/" + id);
                    window.location.reload();
                  })
                  .catch((err) => console.error("Erreur rejet:", err));
              }}
            >
              Rejeter le projet
            </button>
          </div>
        )}
        <section className="project-card">
          <div>{project.status}</div>
          <h2>
            <strong>{project.title}</strong>
            {project.subtitle ? ` : ${project.subtitle}` : ""}
          </h2>

          <p className="description">
            <strong>Description :</strong> {project.description}
          </p>

          <div className="code-section">
            <h3>Code :</h3>
            {project.content?.link ? (
              <p>
                🔗{" "}
                <a
                  href={project.content.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {project.content.link}
                </a>
              </p>
            ) : (
              <p style={{ color: "#aaa" }}>Non disponible</p>
            )}
          </div>

          <div className="details">
            <p>
              <strong>Auteur (Realisateur(s) du projet)</strong> :{" "}
              {project.author}
            </p>
            <p>
              <strong>Année</strong> : {project.year}
            </p>
            <p>
              <strong>Projet inséré par</strong> :{" "}
              {project.created_by_username || "?"}
            </p>
          </div>
        </section>

        <footer className="footer">
          <p>
            Vous aussi, laissez votre empreinte ! Ajoutez votre projet et
            contribuez à l’enrichissement du patrimoine algérien. Merci pour
            votre engagement.
          </p>
          <button onClick={() => navigate("/projects/new")}>
            Ajouter un projet
          </button>
        </footer>
      </main>
    </div>
  );
}
